import { render, staticRenderFns } from "./TopLevelStats.vue?vue&type=template&id=3aa10c3d"
import script from "./TopLevelStats.vue?vue&type=script&lang=js"
export * from "./TopLevelStats.vue?vue&type=script&lang=js"
import style0 from "./TopLevelStats.vue?vue&type=style&index=0&id=3aa10c3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports